import merge from "lodash.merge";
import { call, fork, join, put, SagaGenerator, takeLatest } from "typed-redux-saga";

import {
	Activity,
	ActivityActions,
	ActivityMap,
	ActivitySelectors
} from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { NEW_INSTANCE_IDENTIFIER } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { StoreSagas } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { FormActivity, FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

import { getLatestApplicationVersion } from "../../../utilities/rpcHelper";
import { createCustomNotificationAction } from "../../../app/actions";
import { RESOURCE_KEYS } from "../../../localization";

import { createNewDocument } from "../actions";

export function* injectKeyAndClientSaga(): SagaGenerator<void> {
	yield* takeLatest(
		createNewDocument,
		function* handleOpenStammdaten({
			payload: { activityId: parentActivityId, model, key, client, childActivityId, appId }
		}) {
			if (!model.endsWith("_StammdatenBasis_S_D")) {
				return;
			}

			const findActivity = ({ id, initiatingActivityId, descriptor: { instance } }: Activity): boolean => {
				return (
					initiatingActivityId === parentActivityId &&
					instance === NEW_INSTANCE_IDENTIFIER &&
					// there might still be a child activity from a previous
					// document creation with the same instance, we need to make sure to not select this one
					id !== childActivityId
				);
			};

			const activityId = yield* call(() =>
				StoreSagas.waitFor(
					state => ActivityMap.toList(ActivitySelectors.activities()(state)).find(findActivity)?.id
				)
			);

			const data = yield* call(() =>
				StoreSagas.waitFor(state => {
					const data = ActivitySelectors.data(activityId)(state);
					return FormActivity.Data.SingleDocumentData.isInstance(data) ? data : undefined;
				})
			);

			if (data.document.id !== NEW_INSTANCE_IDENTIFIER) {
				return;
			}
			const latestApplicationVersionRequest = yield* fork(getLatestApplicationVersion, key);
			yield* put(FormEngineActions.command({ activityId, engineEvent: Commands.setReadonly(true) }));
			const latestApplicationVersion = yield* join(latestApplicationVersionRequest);
			if (latestApplicationVersion !== appId) {
				yield* put(
					createCustomNotificationAction({
						activityId: parentActivityId,
						severity: "error",
						message: { key: RESOURCE_KEYS.wf.notification.error.stammdatenVersion.message },
						title: { key: RESOURCE_KEYS.wf.notification.error.stammdatenVersion.title }
					})
				);
				return;
			}
			yield* put(
				ActivityActions.setData({
					activityId,
					data: merge({}, data, {
						document: { root: { stammdatenDefault: { stammdatenMetadata: { key, client } } } }
					})
				})
			);
			yield* put(FormEngineActions.command({ activityId, engineEvent: Commands.setReadonly(false) }));
		}
	);
}
